module.exports = __webpack_public_path__ + "static/media/aswin.47351f1a.jpg";